import RecommendResult from '../components/recommendpage/RecommendResult';

const RecommendResultPage = () => {
    return (
        <>
            <RecommendResult />
        </>
    );
};

export default RecommendResultPage;
